import ApiService from '../../../../../services/ApiService'
import ManageAlert from '../../../Alert/components/manageAlert/ManageAlert.vue'
import ManageCalibrationPatternMetrics from '../ManageCalibrationPatternMetrics/ManageCalibrationPatternerMetrics.vue'
import ManageCalibrationPatternMetricsRanges from '../ManageCalibrationPatternMetricsRange/ManageCalibrationPatternerMetricsRanges.vue'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    ManageAlert,
    ManageCalibrationPatternMetrics,
    ManageCalibrationPatternMetricsRanges,
    InstitutionInactive,
  },

  props: {
    calibrationPatternIdProps: String,
  },

  created() {
    window.scrollTo(0, 0)
    this.visualization = this.isVisualization
    this.userLogged = JSON.parse(localStorage.getItem('user'))

    this.getInstitutions()
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.institutionInactive = this.institution.status == 1

    if (this.calibrationPatternIdProps) {
      this.getParttern()
    }

    this.selectedInstitution()
  },

  data: () => ({
    expanded: [],
    metricSelected: [],
    institution: {},
    step: 0,
    errorMessage: '',
    successMessage: '',
    requestObservation: '',
    inputDisabled: false,
    loading: false,
    unidadeLoading: false,
    institutionLoading: false,
    calibrationPatternLoading: false,
    sendRequestLoading: false,
    metricLoading: false,
    metricRangeLoading: false,
    deleteLoading: false,
    firstValid: true,
    secondValid: true,
    alterDialog: false,
    alertDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    menuValidateDate: false,
    metricDialog: false,
    editMetricDialog: false,
    deleteMetricDialog: false,
    metricRangeDialog: false,
    editMetricRangeDialog: false,
    deleteMetricRangeDialog: false,
    alienateDialog: false,
    useRequestDialog: false,
    dialogKey: false,
    showSuccess: false,
    buttonsVisible: false,
    anotherInstitution: false,
    institutionInactive: false,
    visualization: false,
    validateDate: null,
    userLogged: {},
    unidadeId: 0,
    unidades: [],
    institutionId: 0,
    institutionRequesterId: 0,
    institutionRequestedId: 0,
    institutionsRequested: [],
    institutions: [],
    alert: {},
    currentMetric: {},
    currentMetricRange: {},
    metrics: [],
    metricRanges: [],
    calibrationPatternId: 0,
    calibrationPatterns: [],
    currentCalibrationPattern: {
      id: 0,
      name: '',
      propertyCode: '',
      model: '',
      serialNumber: '',
      manufacturer: '',
      certifiedNumber: '',
      certifiedValidate: null,
      calibratingOrgan: '',
    },
    calibrationPatternTypes: ['Simulador', 'Analisador'],
    nameRules: [
      (v) => !!v || 'Padrão é requerido',
      (v) =>
        (v && v.length <= 128) || 'Padrão deve ter no máximo 128 caracteres',
    ],
    propertyCodeRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Código patrimônio deve ter no máximo 20 caracteres',
    ],
    modelRules: [
      (v) => !!v || 'Modelo é requerido',
      (v) => (v && v.length <= 80) || 'Modelo deve ter no máximo 80 caracteres',
    ],
    serialNumberRules: [
      (v) => !!v || 'Nº de série é requerido',
      (v) =>
        (v && v.length <= 25) || 'Nº de série deve ter no máximo 25 caracteres',
    ],
    manufacturerRules: [
      (v) => !!v || 'Fabricante é requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Fabricante deve ter no máximo 128 caracteres',
    ],
    certifiedNumberRules: [
      (v) => !!v || 'Número do certificado é requerido',
      (v) =>
        (v && v.length <= 20) ||
        'Número do certificado deve ter no máximo 20 caracteres',
    ],
    calibrationOrganRules: [
      (v) => !!v || 'Órgão calibrador é requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Órgão calibrador deve ter no máximo 20 caracteres',
    ],
    unidadeRules: [(v) => !!v || 'Unidade é requerida'],
    institutionRules: [(v) => !!v || 'Instituição é requerida'],
    typeRules: [(v) => !!v || 'Tipo é requerido'],
    apiService: new ApiService(),
    metricHeaders: [
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
      {
        text: 'Resolução',
        align: 'center',

        value: 'resolution',
        sortable: false,
      },
      {
        text: 'Faixas',
        align: 'center',

        value: 'ranges',
        sortable: false,
      },
    ],
    RangeHeaders: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Faixa',
        align: 'center',

        value: 'range',
      },
      {
        text: 'K',
        align: 'center',

        value: 'k',
        sortable: false,
      },
      {
        text: 'Incerteza',
        align: 'center',

        value: 'uncertainty',
        sortable: false,
      },
      {
        text: 'Tendência',
        align: 'center',

        value: 'tendency',
        sortable: false,
      },
      {
        text: 'Ações',

        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    metricHeadersMobile: [
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
      {
        text: 'Resolução',
        align: 'center',

        value: 'resolution',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    autocompleteFilter(item, queryText, itemText) {
      const textOne = item.propertyCode ? item.propertyCode.toLowerCase() : ''
      const textTwo = item.name ? item.name.toLowerCase() : ''
      const textThree = item.serialNumber ? item.serialNumber.toLowerCase() : ''
      const searchText = queryText ? queryText.toLowerCase() : ''

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1
      )
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/calibration?tab=pattern')
      }
    },

    closeDialog() {
      if (this.metricDialog || this.editMetricDialog) {
        this.metricDialog = false
        this.editMetricDialog = false
        this.getCalibrationPatternMetrics()
      } else if (this.metricRangeDialog || this.editMetricRangeDialog) {
        this.metricRangeDialog = false
        this.editMetricRangeDialog = false
        this.getCalibrationPatternMetrics()
      } else if (this.alertDialog) {
        this.alertDialog = false
      } else {
        this.changedData = false
        this.close()
      }
    },

    addMetric() {
      this.metricDialog = true
      this.dialogKey = !this.dialogKey
    },

    editMetric(metric) {
      if (this.anotherInstitution || this.inputDisabled) {
        return
      } else {
        this.currentMetric = metric instanceof Array ? metric[0] : metric
        this.editMetricDialog = true
        this.dialogKey = !this.dialogKey
      }
    },

    deleteMetric(metric) {
      this.currentMetric = metric[0]
      this.deleteMetricDialog = true
      this.dialogKey = !this.dialogKey
    },

    addMetricRange(metric) {
      this.currentMetric = metric
      this.metricRangeDialog = true
      this.dialogKey = !this.dialogKey
    },

    editMetricRange(range) {
      this.currentMetricRange = range
      this.editMetricRangeDialog = true
      this.dialogKey = !this.dialogKey
    },

    deleteMetricRange(range) {
      this.currentMetricRange = range
      this.deleteMetricRangeDialog = true
      this.dialogKey = !this.dialogKey
    },

    alienate() {
      this.alienateDialog = true
      this.dialogKey = !this.dialogKey
    },

    anotherInstitutionRules(value) {
      return !this.anotherInstitution && (value == null || value == 0)
    },

    createAlertCertifiedValidate() {
      this.alert = {
        description: `Vencimento do certificado de calibração do padrão - ${this.currentCalibrationPattern.name}`,
        eventDate: this.parseDate(this.validateDate),
        alertModule: 4,
        calibrationPatternId: this.currentCalibrationPattern.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    showSuccessAlert(message) {
      this.successMessage = message
      this.alienateDialog = false

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
        this.closeDialog()
      }, 2000)
    },

    sendRequest() {
      if (this.$refs.firstForm.validate()) {
        this.useRequestDialog = true
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    async getParttern() {
      await this.apiService
        .get(`calibrationPattern/${this.calibrationPatternIdProps}`)
        .then((response) => {
          this.currentCalibrationPattern = response.content
          this.validateDate = this.formatInitialDate(
            response.content.certifiedValidate
          )
          this.unidadeId = response.content.unidadeId
          if (this.institutionId != response.content.institutionId) {
            this.visualization = true
            this.inputDisabled = true
          }
          this.currentCalibrationPattern.calibrationPatternType =
            this.calibrationPatternTypes[
              response.content.calibrationPatternType
            ]
          this.anotherInstitution = false
          this.isEditing = true

          this.getCalibrationPatternMetrics()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 409) {
            this.$router.go(-1)
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/ListUser').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async submit() {
      this.loading = true

      if (this.$refs.firstForm.validate() & this.$refs.secondForm.validate()) {
        const calibrationPattern = {
          Id: this.currentCalibrationPattern.id,
          Name: this.currentCalibrationPattern.name,
          PropertyCode: this.currentCalibrationPattern.propertyCode,
          Model: this.currentCalibrationPattern.model,
          SerialNumber: this.currentCalibrationPattern.serialNumber,
          Manufacturer: this.currentCalibrationPattern.manufacturer,
          CertifiedNumber: this.currentCalibrationPattern.certifiedNumber,
          CertifiedValidate: this.currentCalibrationPattern.certifiedValidate,
          CalibratingOrgan: this.currentCalibrationPattern.calibratingOrgan,
          CalibrationPatternType: this.calibrationPatternTypes.indexOf(
            this.currentCalibrationPattern.calibrationPatternType
          ),
          UnidadeId: this.unidadeId,
          InstitutionId: this.institutionId,
        }

        let url = 'calibrationPattern/add'

        if (this.isEditing) {
          url = 'calibrationPattern/edit'
        }

        await this.apiService
          .post(url, calibrationPattern)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert(response.message)
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.changedData = false
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.loading = false
    },

    async alienatePattern() {
      this.loading = true

      const calibrationPattern = {
        Id: this.currentCalibrationPattern.id,
        Alienated: !this.currentCalibrationPattern.alienated,
        AlienatedDate: this.currentCalibrationPattern.alienatedDate,
      }

      await this.apiService
        .post('calibrationPattern/alienate', calibrationPattern)
        .then((response) => {
          window.scrollTo(0, 0)
          this.showSuccessAlert(response.message)
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.changedData = false
      this.loading = false
    },

    async sendUseRequest() {
      this.sendRequestLoading = true

      if (this.userLogged.mainType == 0) {
        this.institutionId = this.institutionRequestedId
      }

      const calibrationPatternUseRequest = {
        InstitutionRequesterId: this.institutionRequesterId,
        InstitutionRequestedId: this.institutionId,
        CalibrationPatternRequesterId: this.calibrationPatternId,
        UseRequestObservation: this.requestObservation,
        UserRequesterId: this.userLogged.id,
      }

      await this.apiService
        .post('calibrationPattern/useRequest', calibrationPatternUseRequest)
        .then((response) => {
          window.scrollTo(0, 0)
          this.useRequestDialog = false
          this.showSuccessAlert(response.message)
        })
    },

    async getCalibrationPatternMetrics() {
      await this.apiService
        .get(
          `calibrationPatternMetrics/list/${this.currentCalibrationPattern.id}`
        )
        .then((response) => {
          this.metrics = response.content
        })
    },

    selectedInstitution() {
      this.getUnidades()

      if (this.anotherInstitution) {
        this.listCalibrationPaterns()
      }
    },

    selectedAnotherInstitution() {
      if (!this.anotherInstitution) {
        this.currentCalibrationPattern = {}
        this.institutionId = this.institutionId
        if (this.institutionId) {
          this.getUnidades()
        }
        this.unidadeId = null
        this.institutionRequestedId = null
        this.institutionRequesterId = null
        this.calibrationPatternId = null
      } else {
        this.institutionRequesterId = this.institutionId

        if (this.institutionRequesterId) {
          this.updateListInstitutions(this.institutionRequesterId)
        }
      }
    },

    updateListInstitutions(value) {
      if (value) {
        this.institutionsRequested = this.institutions.filter(
          (x) => x.id != value
        )
      }
    },

    selectedCalibrationPattern(value) {
      if (value) {
        this.currentCalibrationPattern = this.calibrationPatterns.find(
          (x) => x.id === value
        )
        this.institutionId = this.institutionRequestedId
        this.getUnidades()
        this.unidadeId = this.currentCalibrationPattern.unidadeId
        this.currentCalibrationPattern.calibrationPatternType =
          this.calibrationPatternTypes[
            this.currentCalibrationPattern.calibrationPatternType
          ]
        this.validateDate = this.formatInitialDate(
          this.currentCalibrationPattern.certifiedValidate
        )
      }
    },

    async listCalibrationPaterns() {
      if (this.anotherInstitution) {
        this.calibrationPatternLoading = true

        await this.apiService
          .get(`calibrationPattern/list/${this.institutionRequestedId}`)
          .then((response) => {
            this.calibrationPatterns = response.content
            this.calibrationPatternLoading = false
          })
      }
    },

    async removeMetric() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibrationPatternMetrics/delete', this.currentMetric)
        .then(() => {
          this.deleteLoading = false
          this.deleteMetricDialog = false
          this.getCalibrationPatternMetrics()
          this.metricSelected = []
        })
    },

    async removeMetricRange() {
      this.deleteLoading = true

      await this.apiService
        .delete(
          'calibrationPatternMetricsRange/delete',
          this.currentMetricRange
        )
        .then(() => {
          this.deleteLoading = false
          this.deleteMetricRangeDialog = false
          this.getCalibrationPatternMetrics()
        })
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      if (!dateInitial) return
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.validateDate = this.formatInputDate(
        this.currentCalibrationPattern.certifiedValidate
      )
      this.$refs.menuValidateDate.save(date)
    },
  },

  watch: {
    currentCalibrationPattern: {
      deep: true,
      handler() {
        if (this.inputDisabled) {
          this.changedData = false
        } else {
          this.changedData = true
        }
      },
    },

    metricSelected() {
      this.buttonsVisible = this.metricSelected.length != 0
    },
  },
}
